module.exports = __webpack_public_path__ + "media/club_deals/strategies_horizontal_card1-8ba1872e.webp";